/**
 * One-shot lock for `/bestil` navigations.
 *
 * OrderBySubscription can take several seconds. A second click aborts the
 * in-flight document request and starts over — clicking every few seconds
 * never lands. The first click wins; later clicks are ignored until the
 * page is shown again (including back/forward cache).
 */

export type OrderFlowPendingState = {
  pending: boolean;
  sourceId: string | null;
};

const idleState: OrderFlowPendingState = { pending: false, sourceId: null };
let state: OrderFlowPendingState = idleState;
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((listener) => listener());
}

export function getOrderFlowPending(): OrderFlowPendingState {
  return state;
}

export function subscribeOrderFlowPending(onStoreChange: () => void): () => void {
  listeners.add(onStoreChange);
  return () => {
    listeners.delete(onStoreChange);
  };
}

/** @returns true if this caller now owns the in-flight navigation. */
export function beginOrderFlowNavigation(sourceId: string): boolean {
  if (state.pending) return false;
  state = { pending: true, sourceId };
  emit();
  return true;
}

export function resetOrderFlowNavigation() {
  if (!state.pending) return;
  state = idleState;
  emit();
}

if (typeof window !== 'undefined') {
  window.addEventListener('pageshow', resetOrderFlowNavigation);
}
